import React from 'react';

export const srOnly = 'sr-only';

export const headerCell =
  'px-4 py-2 bg-blue-600 text-white text-xs md:text-sm font-semibold text-center border border-white';
export const valueCell =
  'px-4 py-3 text-gray-800 text-xs md:text-sm bg-gray-50 border border-gray-200';

export const LabeledInput: React.FC<{
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  describedById?: string;
  ariaInvalid?: boolean;
}> = React.memo(
  ({ id, label, value, onChange, placeholder, describedById, ariaInvalid }) => {
    return (
      <div>
        <label htmlFor={id} className={srOnly}>
          {label}
        </label>
        <input
          id={id}
          type='text'
          className='w-full px-2 py-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
          placeholder={placeholder}
          value={value}
          onChange={e => onChange(e.target.value)}
          aria-label={label}
          aria-invalid={ariaInvalid ? true : undefined}
          aria-describedby={describedById}
        />
      </div>
    );
  }
);

export const LabeledSelect: React.FC<{
  id: string;
  label: string;
  value: string | number | '';
  onChange: (value: number | '') => void;
  options: Array<{ value: string | number; label: string }>;
  describedById?: string;
  ariaInvalid?: boolean;
  disabled?: boolean;
}> = React.memo(
  ({
    id,
    label,
    value,
    onChange,
    options,
    describedById,
    ariaInvalid,
    disabled
  }) => {
    return (
      <div>
        <label htmlFor={id} className={srOnly}>
          {label}
        </label>
        <select
          id={id}
          className='w-full px-2 py-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
          value={value === '' ? '' : Number(value)}
          onChange={e =>
            onChange(e.target.value === '' ? '' : Number(e.target.value))
          }
          aria-label={label}
          aria-invalid={ariaInvalid ? true : undefined}
          aria-describedby={describedById}
          disabled={disabled}
        >
          {options.map(opt => (
            <option key={String(opt.value)} value={String(opt.value)}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
);
